<template>
  <div class="h-full w-full">
    <div class="my-10px flex items-center h-36px">
      <TableButtonGroup :list="btnList" v-model="btn" @btn-click="btnTabClick"></TableButtonGroup>
    </div>
    <work-ticket-list :type="metalBimSelectValue" :player="player" v-if="btn === '工作票'" />
    <operation-ticket-list :player="player" v-if="btn === '操作票'" />
    <danger-ticket-list :player="player" v-if="btn === '危险作业票'" />
  </div>
</template>

<script>
const TableButtonGroup = () => {
  return import('@/components/cockpit/TableButtonGroup')
}

// components
const WorkTicketList = () => {
  return import('./WorkTicketList')
}
// components
const DangerTicketList = () => {
  return import('./DangerTicketList')
}

const OperationTicketList = () => {
  return import('./OperationTicketList')
}

// const metalBIMApi = new MetalBIMApi()
export default {
  components: { TableButtonGroup, WorkTicketList, OperationTicketList, DangerTicketList },
  name: 'JiNanTwoTicket',
  props: {
    player: {
      type: Object,
      default: () => {},
    },
  },
  WorkTicketListprops: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      metalBimSelectValue: '',
      btn: '工作票',
      btnList: ['工作票', '操作票', '危险作业票'],
    }
  },
  watch: {
    transferProps: {
      handler(val) {
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async metalBimSelect(val) {
      this.type = val
    },
    btnTabClick(val) {
      this.btn = val
    },
  },
  created() {},
  beforeDestroy() {
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
</style>
